import { render, staticRenderFns } from "./withdraw-brand-detail.vue?vue&type=template&id=a79bf356&scoped=true&"
import script from "./withdraw-brand-detail.vue?vue&type=script&lang=js&"
export * from "./withdraw-brand-detail.vue?vue&type=script&lang=js&"
import style0 from "./withdraw-brand-detail.vue?vue&type=style&index=0&id=a79bf356&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79bf356",
  null
  
)

export default component.exports